module.exports = __webpack_public_path__ + "static/img/Download_on_the_App_Store.3ed6562.png";